export default {
	name: "loading-spinner",
	props: ["showSpinner"],
	data() {
		return {
			
		};
	},
	methods: {
		
	},
	mounted: function () {
		
	}
};